/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'unsupported.pageTitle',
    defaultMessage: 'Unsupported Browser',
  },
  title: {
    id: 'unsupported.title',
    defaultMessage: 'This browser is unsupported.',
  },
});
